import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';
import { testimonials } from '@/mocks/home';
import { useState, FormEvent } from 'react';

export default function AboutPage() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [statusMsg, setStatusMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setStatusMsg('发送成功！我们会尽快回复您。');
      setFormData({ name: '', email: '', message: '' });
      return;
    }
    const fd = new FormData(form);
    try {
      const res = await fetch('https://readdy.ai/api/form/d9mu054it35ii3jdllug', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      const code = (parsed as Record<string, string> | null)?.code;
      if (res.ok && code === 'OK') {
        setStatus('success');
        setStatusMsg('发送成功！我们会尽快回复您。');
        setFormData({ name: '', email: '', message: '' });
      } else {
        const serverMsg = (parsed as Record<string, string> | null)?.meta?.message
          || (parsed as Record<string, string> | null)?.message
          || text
          || '发送失败，请稍后重试';
        setStatus('error');
        setStatusMsg(serverMsg.includes('spam') ? '发送失败，请稍后重试' : serverMsg);
      }
    } catch {
      setStatus('error');
      setStatusMsg('网络错误，请检查连接后重试');
    }
  };

  return (
    <>
      <Navbar />
      <main>
        <nav className="pt-20 pb-4 px-4 md:px-6 bg-background-50" aria-label="面包屑导航">
          <div className="max-w-4xl mx-auto">
            <ol className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
              <li><Link to="/" className="hover:text-primary-500 transition-colors">首页</Link></li>
              <li><i className="ri-arrow-right-s-line"></i></li>
              <li><span className="text-foreground-700">关于我们</span></li>
            </ol>
          </div>
        </nav>

        <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-4 text-center">
              关于茄子视频
            </h1>
            <p className="text-sm md:text-base text-foreground-600 text-center max-w-2xl mx-auto mb-12 leading-relaxed">
              茄子视频是专业的<strong>影视平台推荐</strong>导航网站，致力于为影迷朋友提供最优质的<strong>在线看视频</strong>体验
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-14">
              <div className="bg-background-100 rounded-xl p-6 border border-background-200/60">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 mb-4">
                  <i className="ri-lightbulb-line text-xl text-primary-500"></i>
                </div>
                <h2 className="text-lg font-semibold text-foreground-950 mb-3">品牌故事</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  茄子视频成立于2024年，由一群热爱影视的年轻人创立。我们发现很多用户在寻找<strong>好用视频网站</strong>时常常遇到困难——
                  要么资源不全，要么播放卡顿，要么充斥着广告。于是我们决定做一个真正为用户着想的<strong>视频平台推荐</strong>导航站。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mt-3">
                  我们的团队每天浏览评测上百个<strong>视频网站</strong>，精心筛选出像<strong>红桃视频</strong>、<strong>红杏视频</strong>这样真正优质的平台，
                  确保每一部<strong>免费电影</strong>和<strong>免费电视剧</strong>都能<strong>高清免费不缓冲</strong>地呈现在您面前。
                </p>
              </div>

              <div className="bg-background-100 rounded-xl p-6 border border-background-200/60">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 mb-4">
                  <i className="ri-crosshair-line text-xl text-accent-600"></i>
                </div>
                <h2 className="text-lg font-semibold text-foreground-950 mb-3">我们的使命</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  让每一个人都能轻松找到最适合自己的<strong>视频平台</strong>。不论您喜欢看最新上映的院线大片，
                  还是热衷追热门国产剧、韩剧、美剧，茄子视频都能帮您快速定位到最好的资源。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mt-3">
                  我们坚持客观公正的评测标准，不偏袒任何平台，一切以用户体验为导向。
                  目前茄子视频已收录超过30个优质<strong>视频平台</strong>，累计帮助超过5000万用户找到了心仪的观影渠道。
                </p>
              </div>
            </div>

            <div className="mb-14">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-8 text-center">用户口碑</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {testimonials.map((t) => (
                  <div key={t.id} className="bg-background-100 rounded-xl p-5 border border-background-200/60">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">&ldquo;{t.comment}&rdquo;</p>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200">
                        <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" loading="lazy" />
                      </div>
                      <span className="text-sm font-semibold text-foreground-950">{t.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-14">
              <div className="bg-background-100 rounded-xl p-6 border border-background-200/60">
                <h2 className="text-lg font-semibold text-foreground-950 mb-4">联系我们</h2>
                <ul className="space-y-3">
                  <li className="flex items-center gap-3 text-sm text-foreground-700">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                      <i className="ri-mail-line text-primary-500"></i>
                    </div>
                    <span>contact@qiezi.video</span>
                  </li>
                  <li className="flex items-center gap-3 text-sm text-foreground-700">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                      <i className="ri-wechat-line text-accent-600"></i>
                    </div>
                    <span>微信公众号：茄子视频官方</span>
                  </li>
                  <li className="flex items-center gap-3 text-sm text-foreground-700">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 flex-shrink-0">
                      <i className="ri-weibo-line text-secondary-600"></i>
                    </div>
                    <span>微博：@茄子视频官方</span>
                  </li>
                </ul>
              </div>

              <div className="bg-background-100 rounded-xl p-6 border border-background-200/60">
                <h2 className="text-lg font-semibold text-foreground-950 mb-4">给我们留言</h2>
                <form onSubmit={handleSubmit} className="space-y-3" data-readdy-form="">
                  <div className="anti-spam-field">
                    <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                  </div>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    placeholder="您的称呼"
                    required
                    className="w-full px-3 py-2.5 rounded-lg bg-background-50 border border-background-200/60 text-sm text-foreground-950 placeholder-foreground-400 focus:outline-none focus:border-primary-300"
                  />
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    placeholder="您的邮箱"
                    required
                    className="w-full px-3 py-2.5 rounded-lg bg-background-50 border border-background-200/60 text-sm text-foreground-950 placeholder-foreground-400 focus:outline-none focus:border-primary-300"
                  />
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    placeholder="请输入留言内容"
                    required
                    maxLength={500}
                    rows={3}
                    className="w-full px-3 py-2.5 rounded-lg bg-background-50 border border-background-200/60 text-sm text-foreground-950 placeholder-foreground-400 focus:outline-none focus:border-primary-300 resize-none"
                  />
                  <button
                    type="submit"
                    className="w-full px-4 py-2.5 bg-primary-500 text-background-50 font-semibold rounded-lg text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    发送留言
                  </button>
                  {status !== 'idle' && (
                    <p className={`text-xs ${status === 'success' ? 'text-accent-700' : 'text-red-500'}`}>
                      {statusMsg}
                    </p>
                  )}
                </form>
              </div>
            </div>

            <section className="bg-background-100 rounded-xl p-6 border border-background-200/60">
              <h2 className="text-lg font-semibold text-foreground-950 mb-4">常见问题</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">茄子视频是视频播放平台吗？</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    茄子视频是一个<strong>影视平台推荐</strong>导航网站，我们不直接提供视频播放服务，
                    而是为您筛选和推荐最优质的<strong>视频网站</strong>，帮助您快速找到想看的<strong>免费电影</strong>和<strong>免费电视剧</strong>。
                  </p>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">推荐的平台真的免费吗？</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    是的，我们推荐的<strong>红桃视频</strong>、<strong>红杏视频</strong>等平台均提供<strong>高清免费</strong>观影服务，
                    无需付费即可畅享海量影视资源。部分平台可能有少量广告，但整体观影体验优秀。
                  </p>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">如何保证推荐的平台好用？</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    我们的团队每天都会对推荐平台进行实际体验测试，从画质、流畅度、资源丰富度、
                    更新速度等多个维度综合评估，确保每一个推荐都经得起考验。
                  </p>
                </div>
              </div>
            </section>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}